export default __webpack_public_path__ + "static/background4-c863b52270a9a71f44cd331e4ba84a3b.png";